export const PAYMENT_METHODS = {
  TAMARA_PAY_CARD: 'TamaraPayCard',
}
